/*
 * Project: BookingEngine
 * Module: components/booking/rooms/RoomDetail.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Quota from '../Quota';
import RoomHighlights from '../RoomHighlights';
import DsList from '../../../ds/atoms/list';

import { getKeySellingPoints } from '../RoomKeySellingPoints';

import { getLangValue } from '../../../../utils/Generic';

const filterAmenities = (amenities) => {
  const freeAmenities = [];
  const extraAmenities = [];
  amenities.forEach((amenity) => {
    if (amenity.extra_cost) {
      extraAmenities.push(amenity);
    } else {
      freeAmenities.push(amenity);
    }
  });
  return { freeAmenities, extraAmenities };
};

const AmenitiesList = ({ items, title, lang }) => {
  if (items.length < 1) {
    return null;
  }
  const langValue = items[0].name ? 'name' : 'text';
  const itemsList = items.map((item) => (
    {
      id: item.id,
      title: getLangValue(item, lang, langValue).toLowerCase(),
    }
  ));
  return (
    <div className="flex-grow-default mx-2 my-4">
      <h3 className="text-lg text-gray-900 font-bold border-b border-teal-400 py-1 my-2 capitalize">{title}:</h3>
      <DsList items={itemsList} iconDefault="dot" variant="teal" className="text-sm capitalize font-extrabold"/>
    </div>
  );
};

const RoomDetail = ({
  children, className, room, lang, chain,
}, context) => {
  if (!room) {
    return null;
  }
  const { highlights, amenities } = room;
  const hasAmenities = amenities.length > 0;
  // Get Amenities.
  const { freeAmenities, extraAmenities } = filterAmenities(amenities);
  // Get Selling Points.
  const sellingPoints = getKeySellingPoints([room]);
  return (
    <section className={`${className || ''} p-4`}>
      <header className="flex">
        <h2 className="text-primary-500 uppercase text-2xl font-extrabold mr-auto">
          {getLangValue(room, lang, 'name').toLocaleLowerCase()}
        </h2>
        <Quota quota={room.quota} chain={chain} />
      </header>
      <p className="mt-2 mb-4">
        {getLangValue(room, lang, 'description')}
      </p>
      <RoomHighlights highlights={highlights} lang={lang} />
      {hasAmenities && <div className="flex -mx-2 flex-wrap">
        <AmenitiesList items={freeAmenities} title={context.t('What is included')} lang={lang} />
        <AmenitiesList items={extraAmenities} title={context.t('Extra cost')} lang={lang} />
        <AmenitiesList items={sellingPoints} title={context.t('Key selling points')} lang={lang} />
      </div>}
      {children}
    </section>
  );
};

RoomDetail.propTypes = {
  room: PropTypes.object.isRequired,
  format: PropTypes.string,
};

RoomDetail.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect((state) => ({
  chain: state.bookingFormState.chain,
  lang: state.i18nState.lang,
}))(RoomDetail);
